<template>
  <div>
    <!-- Filtros -->
     <div class="w-full flex justify-between below-top-bar">
        <div class="flex">
        </div>

    </div>

    <!-- Tabla de productos -->
    <div class="panel">

      <b-table
        :data="purchases"
        :loading="isLoadingTable"

        paginated
        backend-pagination
        :per-page="perPage"
        :total="total"
        @page-change="onPageChange"

        backend-sorting
        :default-sort="orderField"
        :default-sort-direction="orderDir"
        @sort="onSort"

        class="w-full"
        striped
        bordered
        icon-pack="fas"
        :mobile-cards="false"
        scrollable
      >

        <template>

          <b-table-column field="store_purchases.custom_code" :label="$t('code')" sortable v-slot="props">
            {{ props.row.custom_code }}
          </b-table-column>

          <b-table-column field="store_products.name" :label="$t('material')" sortable v-slot="props">
            {{ props.row.product_name }}
          </b-table-column>

          <b-table-column field="store_providers.name" :label="$t('provider')" sortable v-slot="props">
            {{ props.row.inventory.provider ? props.row.inventory.provider.name :'-' }}
          </b-table-column>

          <b-table-column field="store_purchases.date_purchase" :label="$t('date_purchase')" sortable v-slot="props" centered>
            {{ showDate(props.row.date_purchase) }}
          </b-table-column>

          <b-table-column field="store_purchases.qty" :label="$t('quantity')" sortable v-slot="props" centered>
            {{ showQuantity(props.row.qty) }}
          </b-table-column>

          <b-table-column field="store_purchases.unit_price" :label="$t('unit_price')" sortable v-slot="props" centered>
            {{ showCurrency(props.row.unit_price) }}
          </b-table-column>

          <b-table-column field="store_purchases.price" :label="$t('amount')" sortable v-slot="props" centered>
            {{ showCurrency(props.row.price) }}
          </b-table-column>

          <b-table-column field="store_purchases.delivery_note" :label="$t('delivery_note')" sortable v-slot="props">
            {{ props.row.delivery_note }}
          </b-table-column>

          <b-table-column field="user_id" :label="$t('user')" v-slot="props">
            {{ props.row.user.name }}
          </b-table-column>

          <b-table-column field="store_warehouses.name" :label="$t('storehouse')" sortable v-slot="props">
            {{ props.row.warehouse_name ? props.row.warehouse_name : '' }}
          </b-table-column>

          <b-table-column :label="$t('actions')" field="actions" centered width="150" v-slot="props">
            <div class="w-full h-full flex items-center justify-around">
              <!-- <b-tooltip :label="$t('edit_project')" position="is-left">
                <div @click="editButtonClicked(props.row)"
                     class="cursor-pointer flex text-blue">
                  <b-icon pack="fas" icon="pencil-alt"/>
                </div>
              </b-tooltip> -->
              <!-- <b-tooltip :label="$t('archive_project')" position="is-left">
                <div @click="archiveProjectButtonClicked(props.row.id, props.row.name, props.row.closed_at)"
                     :class=archiveClass(props.row.closed_at)>
                  <b-icon pack="fas" icon="folder-open"/>
                </div>
              </b-tooltip> -->
              <b-tooltip :label="$t('remove_purchase')" position="is-left" type="is-danger">
                <div @click="deleteButtonClicked(props.row.id, props.row.name)"
                     class="cursor-pointer flex text-red">
                  <b-icon pack="fas" icon="trash-alt"/>
                </div>
              </b-tooltip>
            </div>
          </b-table-column>

        </template>

        <template #empty>
          <div class="has-text-centered">{{ $t('no_results') }}</div>
        </template>
      </b-table>

    </div>

  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import axios from 'axios'
  import { parseQuantity, parseDateToDDMMYYYY,formatCurrencyWithoutSymbol, formatCurrency } from './helpers.js'

  export default {

    components: {

    },

    props: {
      projectId: {type: Number, require: true },
    },

    computed: {
      ...mapGetters({
        company: "app/company",
      }),

      filters() {
        let filters = {
          'order_field': this.orderField,
          'order_dir': this.orderDir,
          'perPage': this.perPage,
          'page': this.page,
        }

        return filters
      }
    },

    data: function() {
      return {
        isLoadingTable: true,
        purchases: [],

        perPage: 25,
        orderField: 'store_products.name',
        orderDir: 'asc',
        page: 1,
        last: 1,
        total: 0,

        applyFilters: {}
      }
    },

    created() {
      this.getPurchases()
    },

    methods: {

      async getPurchases(filters=null) {
        this.isLoadingTable = true
        this.purchases = []

        let params = { ...this.filters }

        if( filters != null )
          params = { ...this.filters, ...filters }

        params.filter_project_id = this.projectId
        params.with_totales = 1

        const {data} = await axios.get(`/api/v2/store-purchases`, {params: params})
        if (data && data.success) {
          this.purchases = data.purchases
          this.last = data.lastPage;
          this.total = data.total;
          this.isLoadingTable = false

          this.$emit('epc-totales-fetched', data.totales)
        }
      },

      onSort(field, order) {
        this.projectId = this.projectId
        this.orderField = field
        this.orderDir = order
        this.getPurchases(this.applyFilters)
      },

      onPageChange(page) {
        this.page = page
        this.getPurchases(this.applyFilters)
      },

      reload(arg = {}) {
        this.page = arg.page || 1
        delete arg.page
        // let filters = { ...arg, ...this.filters }
        // if ( !this.isEmptyObject(arg) ) // comentamos por que queremos que siempre se apliquen los filtros aunque llegue vacios
          this.applyFilters = { ...arg }

        this.getPurchases(this.applyFilters);
      },

      async editButtonClicked(entity) {
        this.$emit('epc-edit', entity)
      },

      deleteButtonClicked(purchaseId, purchaseName) {
        this.$dialog.confirm({
          title: this.$t('delete'),
          message: this.$t('delete_confirm_text', ['la compra', purchaseName]),
          confirmText: this.$t('delete') + ' ' + this.$t('purchase'),
          type: 'is-danger',
          hasIcon: true,
          onConfirm: async () => {
            let url = '/api/v2/store-purchase/' + purchaseId + '/delete'
            const {data} = await axios.post(url)
            if (data && data.success) {
              this.$notify.success('success_deleting_generic')
              this.getPurchases(this.applyFilters)
              this.$parent.$emit('epc-updated-list')
            } else {
              this.$notify.error(data.error)
            }
          }
        })
      },

      archiveClass(value) {
        return value ? "cursor-pointer flex text-yellow-dark" : "cursor-pointer flex text-blue"
      },

      handleSelect(newRow, oldRow) {
        this.$emit('update:template', newRow);
      },

      clearSelected() {
        this.rowSelected = null
      },

      showQuantity(qty) {
        return parseQuantity(qty)
      },

      showCurrency(amount, withSimbol = false) {
        return  withSimbol ? formatCurrency(amount) : formatCurrencyWithoutSymbol(amount)
      },

      showDate(date) {
        return parseDateToDDMMYYYY(date);
      },

      isEmptyObject(obj) {
        return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
      },
    },

  };
</script>
